import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	pagesViewNudgeContent: {
		id: 'software-onboarding-nudges--next.pages-create-page.pages-view-nudge-content',
		defaultMessage: 'Create your first page or start from a template.',
		description:
			'Nudge content that will show up to new users when users click on Pages checklist item in quickstart. This Nudge guides the user to create a page in Confluence.',
	},
});
